export enum EntityQueueCqrsActions {
  Create = 'EntityQueueCreateCommand',
  Update = 'EntityQueueUpdateCommand',
  Delete = 'EntityQueueDeleteCommand',
  Get = 'EntityQueueGetQuery',
  List = 'EntityQueueListQuery',
  TransferOwnership = 'EntityQueueTransferOwnershipCommand',
  Execute = 'EntityQueueExecuteQuery',
}
